import {
	callBackPatient,
	editAnswers,
	editEvaluationAnswers,
	endMeeting,
	listAllPrescriptions,
	listAnswers,
	listCIDs,
	listCpts,
	listEvaluationAnswers,
	listPrescriptionAnswers,
	listQuestions,
	saveAnswers,
	saveEvaluation,
	savePrescription,
	sendPrescription,
	listPatientFiles,
	getDoctorMemedToken,
	saveMemedPrescription,
} from "@/services/consultation.service";
import {
	getHealthData as getHealthDataApi,
	updateHealthData as updateHealthDataApi,
} from "@/services/health-data.service";

export default {
	state: {
		questions: [],
		requestStatus: "init",
		requestSaveStatus: "init",
		reqPatientBack: "init",
		reqPatientFiles: "init",
		patientFiles: null,
		CIDs: null,
		cpts: null,
		notification: null,
		sortingAnswers: null,
		evaluationAnswers: null,
		prescriptionAnswers: null,
		healthData: null,
		healthDataStatus: "init",
	},
	getters: {
		getQuestions(state) {
			return state.questions;
		},
		getRequestStatus(state) {
			return state.requestStatus;
		},
		getRequestSaveStatus(state) {
			return state.requestSaveStatus;
		},
		getReqAbsentStatus(state) {
			return state.reqAbsentStatus;
		},
		getReqPatientBack(state) {
			return state.reqPatientBack;
		},
		getCIDs() {
			const CIDs = localStorage.getItem("CIDs");
			if (CIDs != "undefined" && CIDs) return JSON.parse(CIDs);
			else return null;
		},
		getCpts() {
			const cpts = localStorage.getItem("cpts");
			if (cpts != "undefined" && cpts) return JSON.parse(cpts);
			else return null;
		},
		getNotification(state) {
			return state.notification;
		},
		getSortingAnswers(state) {
			return state.sortingAnswers;
		},
		getEvaluationAnswers(state) {
			return state.evaluationAnswers;
		},
		getPrescriptionAnswers(state) {
			return state.prescriptionAnswers;
		},
		getScheduleData() {
			return JSON.parse(localStorage.getItem("scheduleData"));
		},
		getPatientFilesStatus(state) {
			return state.reqPatientFiles;
		},
		getPatientFiles(state) {
			return state.patientFiles;
		},
		getHealthData(state) {
			return state.healthData;
		},
		getHealthDataStatus(state) {
			return state.healthDataStatus;
		},
	},
	mutations: {
		SET_QUESTIONS(state, value) {
			state.questions = value;
		},
		REQUEST_STATUS(state, value) {
			state.requestStatus = value;
		},
		REQUEST_SAVE_STATUS(state, value) {
			state.requestSaveStatus = value;
		},
		PATIENT_BACK_STATUS(state, value) {
			state.reqPatientBack = value;
		},
		SET_CIDs(state, value) {
			localStorage.setItem("CIDs", JSON.stringify(value));
			state.CIDs = value;
		},
		SET_CPTS(state, data) {
			localStorage.setItem("cpts", JSON.stringify(data));
			state.cpts = data;
		},
		SET_NOTIFICATION(state, value) {
			state.notification = value;
			setTimeout(() => {
				state.notification = null;
			}, value.time);
		},
		SET_SORTING_ANSWERS(state, value) {
			state.sortingAnswers = value;
		},
		SET_EVALUATION_ANSWERS(state, value) {
			state.evaluationAnswers = value;
		},
		SET_PRESCRIPTION_ANSWERS(state, value) {
			state.prescriptionAnswers = value;
		},
		SET_SCHEDULE_DATA(state, value) {
			localStorage.setItem("scheduleData", JSON.stringify(value));
		},
		PATIENT_FILES_STATUS(state, value) {
			state.reqPatientFiles = value;
		},
		SET_PATIENT_FILES(state, value) {
			state.patientFiles = value;
		},
		SET_HEALTH_DATA(state, value) {
			state.healthData = value;
		},
		HEALTH_DATA_STATUS(state, value) {
			state.healthDataStatus = value;
		},
	},
	actions: {
		async listOfQuestions({ commit }) {
			commit("REQUEST_STATUS", "pending");
			try {
				const response = await listQuestions();
				commit("REQUEST_STATUS", "init");
				commit("SET_QUESTIONS", response.data.items);
			} catch (error) {
				commit("REQUEST_STATUS", "init");
				throw error;
			}
		},
		async saveSortingAnswers({ commit }, param) {
			commit("REQUEST_SAVE_STATUS", "pending");
			try {
				await saveAnswers(param);
				commit("REQUEST_SAVE_STATUS", "init");
			} catch (error) {
				commit("REQUEST_SAVE_STATUS", "init");
				throw error;
			}
		},
		async saveEvaluationAnswers({ commit }, param) {
			commit("REQUEST_SAVE_STATUS", "pending");
			try {
				await saveEvaluation(param);
				commit("REQUEST_SAVE_STATUS", "init");
			} catch (error) {
				commit("REQUEST_SAVE_STATUS", "init");
				throw error;
			}
		},
		async listOfCIDs({ commit }) {
			commit("REQUEST_STATUS", "pending");
			let allItems = [];
			try {
				let offset = 0;
				const limit = 6500;
				let response = await listCIDs({ limit, offset });
				allItems = [...allItems, ...response.data.items];
				while (response.data.items.length === limit) {
					offset += limit;
					response = await listCIDs({ limit, offset });
					allItems = [...allItems, ...response.data.items];
				}
				commit("REQUEST_STATUS", "init");
				commit("SET_CIDs", allItems);
			} catch (error) {
				commit("REQUEST_STATUS", "init");
				throw error;
			}
		},
		async listOfCpts({ commit }) {
			commit("REQUEST_STATUS", "pending");
			let allItems = []
			try {
				let offset = 0
				const limit = 6500
				let response = await listCpts({ limit, offset })
				allItems = [...allItems, ...response.data.items]
				while (response.data.items.length === limit) {
					offset += limit
					response = await listCpts({ limit, offset })
					allItems = [...allItems, ...response.data.items]
				}
				commit('REQUEST_STATUS', 'init')
				commit('SET_CPTS', allItems)
				return allItems
			} catch (error) {
				commit("REQUEST_STATUS", "init");
				throw error;
			}
		},
		async finishMeeting({ commit }, param) {
			commit("REQUEST_SAVE_STATUS", "pending");
			try {
				await endMeeting(param);
				commit("REQUEST_SAVE_STATUS", "init");
			} catch (error) {
				commit("REQUEST_SAVE_STATUS", "init");
				throw error;
			}
		},
		async savePrescriptionAnswers({ commit }, param) {
			commit("REQUEST_SAVE_STATUS", "pending");
			try {
				const data = await savePrescription(param);
				commit("REQUEST_SAVE_STATUS", "init");
				return data;
			} catch (error) {
				commit("REQUEST_SAVE_STATUS", "init");
				throw error;
			}
		},
		setNotification({ commit }, param) {
			commit("SET_NOTIFICATION", param);
		},
		// async avaliation({ commit }, param) {
		// 	commit("REQUEST_SAVE_STATUS", "pending");
		// 	try {
		// 		await avaliation(param);
		// 		commit("REQUEST_SAVE_STATUS", "init");
		// 	} catch (error) {
		// 		commit("REQUEST_SAVE_STATUS", "init");
		// 		throw error;
		// 	}
		// },
		async listSortingAnswers({ commit }, param) {
			commit("REQUEST_STATUS", "pending");
			try {
				const response = await listAnswers(param);
				commit("REQUEST_STATUS", "init");
				commit("SET_SORTING_ANSWERS", response.data.items[0]);
			} catch (error) {
				commit("REQUEST_STATUS", "init");
				commit("SET_SORTING_ANSWERS", null);
				throw error;
			}
		},
		async editSortingAnswers({ commit }, param) {
			commit("REQUEST_SAVE_STATUS", "pending");
			try {
				await editAnswers(param);
				commit("REQUEST_SAVE_STATUS", "init");
			} catch (error) {
				commit("REQUEST_SAVE_STATUS", "init");
				throw error;
			}
		},
		async listEvaluationAnswers({ commit }, param) {
			commit("REQUEST_STATUS", "pending");
			try {
				const response = await listEvaluationAnswers(param);
				commit("REQUEST_STATUS", "init");
				commit("SET_EVALUATION_ANSWERS", response.data.items[0]);
			} catch (error) {
				commit("REQUEST_STATUS", "init");
				commit("SET_EVALUATION_ANSWERS", null);
				throw error;
			}
		},
		async editEvaluationAnswers({ commit }, param) {
			commit("REQUEST_SAVE_STATUS", "pending");
			try {
				await editEvaluationAnswers(param);
				commit("REQUEST_SAVE_STATUS", "init");
			} catch (error) {
				commit("REQUEST_SAVE_STATUS", "init");
				throw error;
			}
		},
		async listPrescriptionAnswers({ commit }, param) {
			commit("REQUEST_STATUS", "pending");
			try {
				const response = await listPrescriptionAnswers(param);
				commit("REQUEST_STATUS", "init");
				commit("SET_PRESCRIPTION_ANSWERS", response.data.prescriptions);
			} catch (error) {
				commit("REQUEST_STATUS", "init");
				commit("SET_PRESCRIPTION_ANSWERS", null);
				throw error;
			}
		},
		async getAllPrescriptions({ commit }, param) {
			commit("REQUEST_STATUS", "pending");
			try {
				const response = await listAllPrescriptions(param);
				commit("REQUEST_STATUS", "init");
				return response.data.items;
			} catch (error) {
				commit("REQUEST_STATUS", "init");
				throw error;
			}
		},
		setScheduleData({ commit }, param) {
			commit("SET_SCHEDULE_DATA", param);
		},
		async callPatientBack({ commit }, param) {
			commit("PATIENT_BACK_STATUS", "pending");
			try {
				await callBackPatient(param);
				commit("PATIENT_BACK_STATUS", "init");
			} catch (error) {
				commit("PATIENT_BACK_STATUS", "init");
				throw error;
			}
		},
		async sendPrescriptionToPatient({ commit }, param) {
			commit("REQUEST_STATUS", "pending");
			try {
				const { data } = await sendPrescription(param);
				commit("REQUEST_STATUS", "init");
				return data;
			} catch (error) {
				commit("REQUEST_STATUS", "init");
				throw error;
			}
		},
		async getPatientFiles({ commit }, param) {
			commit("PATIENT_FILES_STATUS", "pending");
			try {
				const { data } = await listPatientFiles(param);
				commit("PATIENT_FILES_STATUS", "init");
				commit("SET_PATIENT_FILES", data.pdocs);
				return data.pdocs;
			} catch (error) {
				commit("PATIENT_FILES_STATUS", "init");
				throw error;
			}
		},
		async getDoctorMemedToken({ commit }, param) {
			commit("REQUEST_STATUS", "pending");
			try {
				const { data } = await getDoctorMemedToken(param);
				commit("REQUEST_STATUS", "init");
				return data;
			} catch (error) {
				commit("REQUEST_STATUS", "init");
				throw error;
			}
		},
		async registerMemedPrescription({ commit }, param) {
			commit("REQUEST_SAVE_STATUS", "pending");
			try {
				await saveMemedPrescription(param);
				commit("REQUEST_SAVE_STATUS", "init");
			} catch (error) {
				commit("REQUEST_SAVE_STATUS", "init");
				throw error;
			}
		},
		async fetchHealthData({ commit }, cpf) {
			commit("HEALTH_DATA_STATUS", "pending");
			try {
				const { data } = await getHealthDataApi(cpf);
				commit("SET_HEALTH_DATA", data);
				commit("HEALTH_DATA_STATUS", "init");
				return data;
			} catch (error) {
				commit("SET_HEALTH_DATA", null);
				commit("HEALTH_DATA_STATUS", "init");
				return null;
			}
		},
		async updateHealthData({ commit }, { cpf, payload }) {
			commit("HEALTH_DATA_STATUS", "pending");
			try {
				const { data } = await updateHealthDataApi(cpf, payload);
				commit("SET_HEALTH_DATA", data);
				commit("HEALTH_DATA_STATUS", "init");
				return data;
			} catch (error) {
				commit("HEALTH_DATA_STATUS", "init");
				throw error;
			}
		},
	},
};
